const FLAG_CDN_BASE = 'https://flagcdn.com/w40';

export const countries = [
  { code: 'IN', name: 'India', dialCode: '+91', flag: `${FLAG_CDN_BASE}/in.png` },
  { code: 'US', name: 'United States', dialCode: '+1', flag: `${FLAG_CDN_BASE}/us.png` },
  { code: 'GB', name: 'United Kingdom', dialCode: '+44', flag: `${FLAG_CDN_BASE}/gb.png` },
  { code: 'AE', name: 'United Arab Emirates', dialCode: '+971', flag: `${FLAG_CDN_BASE}/ae.png` },
  { code: 'SG', name: 'Singapore', dialCode: '+65', flag: `${FLAG_CDN_BASE}/sg.png` },
  { code: 'AU', name: 'Australia', dialCode: '+61', flag: `${FLAG_CDN_BASE}/au.png` },
  { code: 'CA', name: 'Canada', dialCode: '+1', flag: `${FLAG_CDN_BASE}/ca.png` },
  { code: 'DE', name: 'Germany', dialCode: '+49', flag: `${FLAG_CDN_BASE}/de.png` },
];

export const DEFAULT_COUNTRY = countries[0];

export function getCountryByCode(code) {
  if (!code) return DEFAULT_COUNTRY;
  return countries.find((country) => country.code === code.toUpperCase()) || DEFAULT_COUNTRY;
}

export function getCountryByDialCode(dialCode) {
  if (!dialCode) return DEFAULT_COUNTRY;
  return countries.find((country) => country.dialCode === dialCode) || DEFAULT_COUNTRY;
}

export default countries;
